import { render } from "./PlatformChange.vue?vue&type=template&id=617324a3&scoped=true"
import script from "./PlatformChange.vue?vue&type=script&lang=js"
export * from "./PlatformChange.vue?vue&type=script&lang=js"

import "./PlatformChange.vue?vue&type=style&index=0&id=617324a3&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617324a3"]])

export default __exports__